import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import RadioWithInput from "component/inputs/radioWithInput/RadioWithInput";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import ValidationMessage from "component/validationMessage/ValidationMessage";

const pfaData = [
  {
    label: "ARM Pension Managers Limited",
    value: "ARM Pension Managers Limited",
    id: 1,
  },
  {
    label: "Crusader Sterling Pensions Limited",
    value: "Crusader Sterling Pensions Limited",
    id: 2,
  },
  {
    label: "FCMB Pensions Limited",
    value: "FCMB Pensions Limited",
    id: 3,
  },
  {
    label: "Fidelity Pension Managers Limited",
    value: "Fidelity Pension Managers Limited",
    id: 4,
  },
  {
    label: "First Guarantee Pension Limited",
    value: "First Guarantee Pension Limited",
    id: 5,
  },
  {
    label: "Guaranty Trust Pension Managers Limited",
    value: "Guaranty Trust Pension Managers Limited",
    id: 6,
  },
  {
    label: "Leadway Pensure PFA Limited",
    value: "Leadway Pensure PFA Limited",
    id: 7,
  },
  {
    label: "Nigerian University Pension Management Company (NUPEMCO)",
    value: "Nigerian University Pension Management Company (NUPEMCO)",
    id: 8,
  },
  {
    label: "NLPC Pension Fund Administrators Limited",
    value: "NLPC Pension Fund Administrators Limited",
    id: 9,
  },
  {
    label: "Norrenberger Pensions Limited",
    value: "Norrenberger Pensions Limited",
    id: 10,
  },
  {
    label: "NPF Pensions Fund Administrators Limited",
    value: "NPF Pensions Fund Administrators Limited",
    id: 11,
  },
  {
    label: "OAK Pensions Limited",
    value: "OAK Pensions Limited",
    id: 12,
  },
  {
    label: "Pensions Alliance Limited",
    value: "Pensions Alliance Limited",
    id: 13,
  },
  {
    label: "Premium Pension Limited",
    value: "Premium Pension Limited",
    id: 14,
  },
  {
    label: "Radix Pension Managers Limited",
    value: "Radix Pension Managers Limited",
    id: 15,
  },
  {
    label: "Sigma Pensions Limited",
    value: "Sigma Pensions Limited",
    id: 16,
  },
  {
    label: "Stanbic IBTC Pension Managers Limited",
    value: "Stanbic IBTC Pension Managers Limited",
    id: 17,
  },
  {
    label: "Tangerine APT Pensions Limited",
    value: "Tangerine APT Pensions Limited",
    id: 18,
  },
  {
    label: "Trustfund Pensions Limited",
    value: "Trustfund Pensions Limited",
    id: 19,
  },
  {
    label: "Veritas Glanvills Pensions Limited",
    value: "Veritas Glanvills Pensions Limited",
    id: 20,
  },
];
function RsaEquityContribution({ formData, register, watch, errors }) {
  const rsa = watch("rsaEquityContribution", "");

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">
              Are you using 25% RSA as Equity contribution{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Typography>
              Please provide the details required as they relate to pension
              backed applications
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <RadioWithInput
                    inputPlaceholder="RSA pin (Numbers Only)"
                    inputName={"rsaPin"}
                    register={register}
                    name="rsaEquityContribution"
                    value={"true"}
                    result={rsa}
                    label="yes"
                  />
                  {errors?.rsaEquityContribution && (
                    <ValidationMessage
                      message={errors?.rsaEquityContribution?.message}
                    />
                  )}
                  {rsa === "true" && (
                    <>
                      {errors?.rsaPin && (
                        <ValidationMessage message={errors?.rsaPin?.message} />
                      )}
                    </>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <RadioWithInput
                    inputName={""}
                    register={register}
                    name="rsaEquityContribution"
                    value={false}
                    // result={rsa === 'true' ? true : false}
                    label="no"
                  />
                </div>
              </Grid>
              {rsa === "true" && (
                <Grid item xs={12} sm={12}>
                  <div className={styles.field}>
                    <LabeledSelect
                      required={true}
                      errors={errors}
                      register={register}
                      data={pfaData}
                      name="pfa"
                      label="Select PFA"
                      placeholder="Select PFA"
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default RsaEquityContribution;